//@ts-nocheck
import React, {
  ChangeEvent,
  useState,
  ChangeEventHandler,
  VFC,
  useEffect,
} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { IReduxState } from '../../../ReduxImpl/reducers/index';
import { FieldProps } from '@sitecore-jss/sitecore-jss-react-forms';
import { FormFieldSection } from '@sitecore-jss/sitecore-jss-forms';
import { checkConditions } from '../../ConditionalRendering/index';
import {
  UpdateConditionalSectionControls,
  UpdateShowSectionStatus,
} from '../../../ReduxImpl/actions';
import { BiWindows } from 'react-icons/bi';

const SectionFeild: VFC<FieldProps<FormFieldSection>> = ({
  field,
  fieldFactory,
}) => {
  //const [hasFocus, setHasFocus] = useState(false);
  //const hasAnyError = !!props.errors?.length;
  //const [value, setValue] = useState(props.value);
  //const hasValueOrFocus = hasFocus || (Array.isArray(value) && value.length > 0 );
  //var options = props.field.model.items.map(x =>  <option value={x.value}>{x.text}</option> );
  //const label = field.model.title;
  const id = field.model.itemId;
  const name = field.model.name;
  const dispatch = useDispatch();
  //const name = field.valueField.name;
  //const FieldValidationErrors = props.fieldValidationErrorsComponent;
  const stateFieldValues = useSelector(
    (state: IReduxState) => state.fieldValues
  );
  const stateConditions = useSelector((state: IReduxState) => {
    return state.conditions[field.model['conditionSettings'].fieldKey];
  });

  const showsection = useSelector((state: IReduxState) => state.showsection);

  let showsection1 = showsection;

  const IsVisible = (fieldValues, conditions, field) => {
    if (!showsection && field.model.name === 'SectionAll') {
      return true;
    } else if (conditions !== undefined && fieldValues !== undefined) {
      let IsSectionHide = checkConditions(fieldValues, conditions);
      dispatch(
        UpdateConditionalSectionControls({
          name: field.model.name,
          IsVisible: !IsSectionHide,
        })
      );
      return IsSectionHide;
    } else {
      return false;
    }
  };

  return (
    <div
      id={field.model.itemId}
      style={{
        display: !IsVisible(stateFieldValues, stateConditions, field)
          ? 'block'
          : 'none',
      }}
    >
      <fieldset className={field.model.cssClass} style={{ margin: 0 }}>
        {!IsVisible(stateFieldValues, stateConditions, field)
          ? field.fields.map(fieldFactory)
          : null}

        {/* {console.log("FORM VIEW.......",!IsVisible(stateFieldValues, stateConditions, field)
          ? field.fields.map(fieldFactory)
          : null)} */}
      </fieldset>
    </div>
  );
};

export default SectionFeild;
